import { Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import "./Record.css";
import { Button, Modal } from "react-bootstrap";
import { useState } from "react";

const Record = ({ record, onDelete, onClone }) => {
  const [showClone, setShowClone] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const handleCloseClone = () => setShowClone(false);
  const handleShowClone = () => setShowClone(true);

  const handleCloseDelete = () => setShowDelete(false);
  const handleShowDelete = () => setShowDelete(true);

  function formatDate(dateString) {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  }

  return (
    <>
      <div className="record">
        <div className="record__title"><a href={`/report/${record.id}`}>{record.title} </a></div>

        <div className="record__info">
          <div className="record__info-title">Status</div>
          <div className="record__info-value">{record.status}</div>
        </div>

        <div className="record__info">
          <div className="record__info-title">Author</div>
          <div className="record__info-value">{record.author}</div>
        </div>

        <div className="record__info">
          <div className="record__info-title">Created</div>
          <div className="record__info-value">{ formatDate(record.created) }</div>
        </div>

        <div className="record__info">
          <div className="record__info-title">Last Modified</div>
          <div className="record__info-value">{ formatDate(record.modified)}</div>
        </div>

        <div className="record__info">
          <div className="record__info-value">
            <DropdownButton id="dropdown-basic-button" title="Actions">
              <Dropdown.Item href={`/pavement-context-basic/${record.id}`}>Edit</Dropdown.Item>
              <Dropdown.Item onClick={handleShowClone}>Clone</Dropdown.Item>
              <Dropdown.Item onClick={handleShowDelete}>Delete</Dropdown.Item>
            </DropdownButton>
          </div>
        </div>
      </div>

      {record.designs.map((design, index) => (
        <div className="design" key={index}>
          <div className="design__record">
            <div className="design__record-info">
              <Link to={`/pavement-design/${record.id}`}>{design.designTitle}</Link>
              {console.log(design)}
            </div>
            <div className="design__record-info">Surface: <b>{design.surface}</b></div>
            <div className="design__record-info">Base: <b>{design.baseGranular}</b></div>
          </div>
        </div>
      ))}

      {/* Clone Modal */}
      <Modal
        show={showClone}
        onHide={handleCloseClone}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Clone Record</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to clone this record?
          <br /><br />
          Cloning this record will create a duplicate entry with the same data. You can edit the cloned record after creation.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseClone}>
            Close
          </Button>
          <Button variant="primary" onClick={() => { onClone(record.id); handleCloseClone(); }}>Clone</Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal
        show={showDelete}
        onHide={handleCloseDelete}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Record</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this record?
          <br /><br />
          Deleting this record is permanent and cannot be undone. All associated data will be lost.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDelete}>
            Close
          </Button>
          <Button variant="danger" onClick={() => { onDelete(record.id); handleCloseDelete(); }}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Record;
